import { injectReducer } from "../../store/reducers";
import { isLoggedIn } from "../../utils/auth";
import {
  loadCustomerGiftVouchersReducer,
  validateOTPReducer,
  generateOTPReducer
} from "./modules/GiftVoucherActivation";

export default (store) => ({
  path: "gift-voucher-activation",
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure(
      [],
      (require) => {
        /*  Webpack - use require callback to define
          dependencies for bundling   */
        const CustomerDetails = require("./containers/GiftVoucherActivation").default;
        injectReducer(store, {
          key: "customerGiftVouchers",
          reducer: loadCustomerGiftVouchersReducer,
        });
        injectReducer(store, {
          key: "giftVoucherValidatedOtpInfo",
          reducer: validateOTPReducer,
        });
        injectReducer(store, {
          key: "giftVoucherOtpInfo",
          reducer: generateOTPReducer,
        });
        cb(null, CustomerDetails);
        /* Webpack named bundle   */
      },
      "giftVoucherActivation"
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/GiftVoucherActivation/index.js